export default "__VITE_ASSET__1oFmVOo9__"